import { Mapper } from "../../../../base/utils/mapper";
import { OthersOptometryResponseModel } from "../../../../domain/models/consult/other-optometry-response.model";
import { OthersOptometryResponseEntity } from "../entities/others-optometry-response.entity";

export class OthersOptometryImplementationRepositoryMapper extends Mapper<OthersOptometryResponseEntity, OthersOptometryResponseModel> {
    mapFrom(param: OthersOptometryResponseEntity): OthersOptometryResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: OthersOptometryResponseModel): OthersOptometryResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}